<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
  /** Для модалок и секций настроек. */
  compact?: boolean;
}>();
</script>

<template>
  <div
    class="flex flex-col items-center px-5 text-center"
    :class="compact ? 'py-8' : 'py-16'"
  >
    <div
      v-if="$slots.icon"
      class="mb-4 flex items-center justify-center rounded-full bg-(--surface-sunken) text-(--text-secondary)"
      :class="compact ? 'size-14 [&_svg]:size-6' : 'size-20 [&_svg]:size-9'"
    >
      <slot name="icon" />
    </div>
    <h2 class="text-lg font-semibold text-(--text-primary)">{{ title }}</h2>
    <p
      v-if="description"
      class="mt-2 max-w-md text-sm text-(--text-secondary)"
    >
      {{ description }}
    </p>
    <div
      v-if="$slots.action"
      class="mt-6"
    >
      <slot name="action" />
    </div>
  </div>
</template>
